/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbGetRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbGlobalConfigUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbGlobalConfigUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ActionApi, GlobalConfig } from './ActionApi.types.tsx';

export const fetchGlobalConfig =
	(shouldRefetch = true): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		if (getState().loading || (!shouldRefetch && getState().config)) {
			return;
		}

		setState({ loading: true, error: undefined });

		try {
			const response: GlobalConfig = await performCmdbGetRequest(
				getCmdbGlobalConfigUrl(workspaceId),
			);

			const iconListWithServiceOTEntriesRemoved = response
				? response.icons.filter(
						(item) =>
							item.name !== 'Applications' &&
							item.name !== 'Business Services' &&
							item.name !== 'Capabilities' &&
							item.name !== 'Software Services',
					)
				: undefined;

			setState({
				...getState(),
				loading: false,
				config: {
					...response,
					restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
					icons: iconListWithServiceOTEntriesRemoved || [],
				},
				referenceTypes: {
					...getState().referenceTypes,
					data: response ? response.referenceTypes : undefined,
				},
				statusTypes: {
					...getState().statusTypes,
					data: response ? response.statusTypes : undefined,
				},
				icons: {
					...getState().icons,
					data: iconListWithServiceOTEntriesRemoved,
				},
				dataManager: {
					...getState().dataManager,
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({ loading: false, error });

			fireCmdbErrorAnalytics({
				meta: {
					id: 'fetchInsightGlobalConfig',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
